import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Column } from 'further-ui/components/Layout';

const Container = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'isRowEnd',
})<{ isRowEnd?: boolean }>(({ theme, isRowEnd }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRight: isRowEnd ? `1px solid ${theme.palette.divider}` : 'none',
  width: '100%',
  padding: theme.spacing(theme.spacingSizes.md),
}));

type Props = {
  label: string;
  value: string;
  isRowEnd?: boolean;
};

const DataPoint: React.FC<Props> = ({ label, value, isRowEnd }) => {
  return (
    <Container isRowEnd={isRowEnd} spacing="xxs">
      <Typography variant="h6" color="grey.600">
        {label}
      </Typography>
      <Typography variant="h5">{value}</Typography>
    </Container>
  );
};

export default DataPoint;
